interface IType {
    Name: 'and' | 'or'
    Value: 0 | 1
}
export class Type {
    public static GetValueFromName(name: IType['Name']): IType['Value'] {
        return name === 'and' ? this.And.Value : this.Or.Value;
    }
    public static GetNameFromValue(value: 0 | 1): IType['Name'] {
        return value === 0 ? this.And.Name : this.Or.Name;
    }
    public static get And(): IType {
        return {
            Name: 'and',
            Value: 0
        };
    }
    public static get Or(): IType {
        return {
            Name: 'or',
            Value: 1
        };
    }
}